import {
  Box,
  Tab,
  Tabs,
} from "@mui/material";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Permission, useGetAssignedPermissions } from "~/hooks/permissions";
import ConfigLoader from "~/components/common/ConfigLoader";
import type { ReactElement } from "react";

type Tabs = Record<string, {
  label: string,
  permission: Permission,
  component: (id?: number) => ReactElement,
}>

type Props = {
  basePath: string,
  loading?: boolean,
  tabs: Tabs,
}

const TabsPage = ({ basePath, loading, tabs }: Props) => {
  const { tab, id } = useParams<{ tab: string, id?: string }>();
  const navigate = useNavigate();

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    navigate(`/${basePath}/${newValue}`);
  };

  const userPerms = useGetAssignedPermissions();

  if (loading || !userPerms) {
    return <ConfigLoader />;
  }

  if (!tab || !tabs[tab] || !userPerms.has(tabs[tab].permission)) {
    const firstTab = Object.keys(tabs).find(tab => userPerms.has(tabs[tab].permission));
    if (firstTab) {
      return <Navigate to={`/${basePath}/${firstTab}`} replace />;
    }
    return <Navigate to="/command" />;
  }

  return <>
    <Box sx={{ borderBottom: 1, borderColor: 'divider', ml: 3, mt: 2 }}>
      <Tabs value={tab} onChange={handleTabChange}>
        {Object.keys(tabs).map(tab => userPerms.has(tabs[tab].permission) ? <Tab label={tabs[tab].label} key={tab} value={tab} /> : null)}
      </Tabs>
    </Box>
    {tabs[tab].component(id ? parseInt(id) : undefined)}
  </>
}

export default TabsPage;
